import type { KeyboardEvent } from "react";

export const isReactKeyboardEvent = (subject: any): subject is KeyboardEvent =>
    !!subject && subject.hasOwnProperty("type") && subject["type"] === "keydown";
